import store from 'localforage';

class Storage {

  static get(key) {
    return store.getItem(key);
  }

  static put(key, value) {
    return store.setItem(key, value);
  }

  static remove(key) {
    return store.removeItem(key);
  }

  static clear() {
    return store.clear();
  }

}

export default Storage;